import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonBar } from "../elements";
import { optimistActions, roleSelector, roleSummarySelector, useOptimistReportDispatch, useOptimistReportSelector, } from "./state";
import { STATUS_ICONS } from "./statusIcons";
const ROLE_NAMES = {
    service: "Services",
    manual: "Manual",
};
export const RoleSwitch = () => {
    const role = useOptimistReportSelector(roleSelector);
    const summary = useOptimistReportSelector(roleSummarySelector);
    const dispatch = useOptimistReportDispatch();
    if (summary.length < 2) {
        return null;
    }
    const items = summary.map(s => ({
        id: s.role,
        title: `${STATUS_ICONS[s.status]} ${ROLE_NAMES[s.role]} ${s.success}/${s.total}`,
    }));
    return (_jsx(ButtonBar, { items: items, activeId: role, onChange: r => dispatch(optimistActions.setRole(r)) }));
};
